export default __webpack_public_path__ + "static/media/MaderasPolanco.8ce562d8.png";